<template>
  <div class="historyUI">
    <div
      class="buttonMini buttonMini--circle38 historyUI__item"
      :class="{ 'button--disable': !isActiveBack }"
      @click="historyBack"
    >
      <img src="@/assets/header/undo.svg" width="16" alt="" />
    </div>
    <div
      class="buttonMini buttonMini--circle38 historyUI__item"
      :class="{ 'button--disable': !isActiveForward }"
      @click="historyForward"
    >
      <img src="@/assets/header/redo.svg" width="16" alt="" />
    </div>
  </div>
</template>

<script>
import { DrawEvent } from "../../events/DrawEvent";
import * as drawEventType from "../../events/DrawEventType";
import * as textTypes from "../../store/modules/tool/types";

export default {
  name: "HistoryUI",
  computed: {
    history() {
      return this.$store.state.history;
    },
    isActiveBack() {
      return this.history.index > 0;
    },
    isActiveForward() {
      return  this.history.index + 1 < this.history.length;
    }
  },
  methods: {
    historyBack() {
      DrawEvent.emit(drawEventType.HISTORY_BACK);
    },
    historyForward() {
      DrawEvent.emit(drawEventType.HISTORY_FORWARD);
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/common"
@import "../../sass/zindex"
.buttonMini
    background-color: $button_bg--dark
.historyUI
    @include flexCenter()
    //.historyUI__item
        opacity: 0.5
        pointer-events: none
        &.active
            opacity: 1
            pointer-events: all
    .buttonMini
        margin-left: 16px
</style>
